<template>
    <CustomHeader :text="$t('activityName.return_turnover')" :show-history="true"
        @openHistoryPopup="openHistoryPopup" />
    <div class="bg-back">
        <img class="bg-top-img" :src="dataSet.bannerIcon">
        <div class="container">
            <img v-if="dataSet.showLeft" src="@/assets/home/game_arrow_white.png"
                style="width: 5%;position: absolute;top: 2vh; z-index: 200;" @click="scrollLeft">
            <img v-if="dataSet.showRight" src="@/assets/home/game_arrow_white.png" @click="scrollRight"
                style="width: 5%;position: absolute;transform: rotate(180deg);right:0;top: 2vh; z-index: 200;">

            <CashbackNotice :content="formattedMessages" />

            <div style="">
                <CashBackCard :title="$t('common.bets')" :create-date="dataSet.todayBetDetails?.createTime"
                    :day="dataSet.todayBetDetails?.dayCount" :showClickButton="dataSet.availableGiftAmount > 0"
                    :available-value="dataSet.availableGiftAmount" :given-value="dataSet.claimGiftAmount"
                    @get-claim="getClaim"
                    :dayList="dataSet.futureRewards.length <= 0 ? getDefaultRewards(dataSet.dayCountVal) : dataSet.futureRewards" />
            </div>

            <CashbackWeekDetails :bet-list="dataSet.weeklyRewardList" :title="$t('activity.bettingAmount')"
                type="TURNOVER" :todayDayRewards="dataSet.todayDayRewards" :cashback-total="dataSet.cashbackTotal"
                :isShowTodayCard="dataSet.isHaveTodayDayRewards"
                :istoday-claimed="dataSet.todayBetDetails?.remainGiftAmount > 0" />

            <CashbackHistoryPopup ref="histryPopupRef" @getHistoryList="getHistoryList" :list="dataSet.historyList"
                @updateHistoryList="getNextPageRewardData"
                :showIcon="dataSet.total > dataSet.pageSize * dataSet.pageNum" :title="$t('activity.bettingAmount')"
                @resetHistoryData="resetHistoryData" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { getDefaultRewards } from '@/utils/commonFunction';
import { ReturnTurnOverData } from '@/view/returnTurnover/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import CashbackNotice from '../components/common/cashbackNotice.vue';
import CashBackCard from '../components/common/cashBackCard.vue';
import CashbackWeekDetails from '../components/common/cashbackWeekDetails.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';

const histryPopupRef = ref()

const formattedMessages = computed(() =>
    props.dataSet.activityDescription.map(msg => msg.replace(/\\n/g, '\n'))
);

const props = defineProps<{
    dataSet: ReturnTurnOverData
}>()

const emits = defineEmits(['scrollLeft', 'scrollRight', 'getNextPageRewardData', 'getClaim', 'getHistoryList', 'resetHistoryData'])

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}

const getClaim = () => {
    emits('getClaim')
}

const getHistoryList = () => {
    emits('getHistoryList')
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}

</script>
<style scoped>
.container {
    padding: 0px;
    position: relative;
    background: #090F1F;
}

.bg-back {
    background: #090F1F;
    min-height: 100vh;
}

.container>>>.van-tabs__nav {
    background: transparent;
    /* padding: 0 15px; */
    margin: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
    /* display: flex;
    justify-content: center; */
}

.image-wrapper {
    position: relative;
    display: inline-block;
    display: flex;
    justify-content: center;
}

.bottom_text {
    padding: 0px 25px;
    margin-top: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
    background-color: #090F1F;
}

.scroll-btn {
    position: absolute;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 1000;
    border-radius: 50%;
    user-select: none;

}

.scroll-btn img {
    width: 10%;
    z-index: 200;
}

.scroll-btn.left {
    left: 50vw;
    width: 4%;
}

.scroll-btn.right {
    right: 0;
}

.right img {
    transform: rotate(180deg) !important;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}
</style>